var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.50989 10.2701L7.02989 8.51009C7.51989 8.27009 7.98989 7.63009 8.07989 7.09009L8.60989 3.90009C8.94989 1.86009 10.4299 1.38009 11.8899 2.85009L14.3699 5.33009C14.7899 5.75009 15.5999 5.98009 16.1799 5.85009L19.2499 5.14009C21.6799 4.58009 22.6199 5.87009 21.3499 8.02009L19.5799 11.0101C19.2599 11.5501 19.2599 12.4401 19.5799 12.9901L21.3499 15.9801C22.6199 18.1201 21.6699 19.4201 19.2499 18.8601L16.1799 18.1501C15.5999 18.0201 14.7899 18.2501 14.3699 18.6701L11.8899 21.1501C10.4299 22.6101 8.94989 22.1401 8.60989 20.1001L8.07989 16.9101C7.98989 16.3801 7.51989 15.7401 7.02989 15.5001L3.50989 13.7401C1.59989 12.7801 1.59989 11.2201 3.50989 10.2701Z",
    fill: "#8DE833",
    stroke: "#8DE833",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star-filled.528370ed74bdf918730edd01aec4400c.svg";
export { ForwardRef as ReactComponent };